var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"navbar-nav"},[_c('li',{staticClass:"nav-item"},[_c('NavbarDropdown',{attrs:{"items":_vm.items,"text":_vm.currentLabel,"variant":_vm.allSelected ? 'warning' : null,"show-search":""},on:{"click:item":_vm.onClick}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }